import React from 'react'

import { Screens } from './components/Screens/Screens'
import { SettingsModal } from './components/SettingsModal/SettingsModal'
import { Border } from './components/Border/Border'

export function App() {
    return (
        <>
            <Screens />
            <SettingsModal />
            <Border />
        </>
    )
}
